// eslint-disable-next-line import/prefer-default-export
export const cartValidator = {
  quantityCheck(cart) {
    const isWithoutQuantity = [];
    cart.forEach((supplier) => {
      if ((supplier.value.find((product) => product.quantity === undefined)) !== undefined) {
        isWithoutQuantity.push(supplier.value);
      }
    });
    return isWithoutQuantity.length ? -1 : 1;
  },
  specificCartQuantityCheck(cart) {
    return cart.find((product) => product.quantity === undefined);
  },
};
